module.exports = __webpack_public_path__ + "static/rosalinda-142bc1ba17e2525dc64d93fc56186b91.png";